import { memo } from 'react';
import { motion } from 'framer-motion';
import { ANSWER_LETTERS } from '../utils/gameData';

const AnswerButtonBase = ({
  index,
  answer,
  state, // 'default' | 'selected' | 'correct' | 'wrong' | 'eliminated'
  onClick,
  disabled,
  audiencePercent,
  /** Révélation après erreur joueur : clignotement vert dédié (sans flash « bonne réponse » classique). */
  wrongOutcomeReveal = false,
}) => {
  const letter = ANSWER_LETTERS[index];
  const wrongRevealBlink = wrongOutcomeReveal && state === 'correct';

  const getStateClasses = () => {
    switch (state) {
      case 'selected':
        return 'answer-btn selected animate-pulse-gold';
      case 'correct':
        if (wrongOutcomeReveal) {
          return 'answer-btn animate-blink-correct-wrong-outcome';
        }
        return 'answer-btn correct glow-green animate-flash-correct';
      case 'wrong':
        return 'answer-btn wrong glow-red animate-shake';
      case 'eliminated':
        return 'answer-btn eliminated';
      default:
        return 'answer-btn';
    }
  };

  return (
    <motion.button
      data-testid={`answer-btn-${letter.toLowerCase()}`}
      className={`${getStateClasses()} hexagon-btn w-full min-w-0 max-w-full py-4 px-4 sm:px-6 flex items-center gap-3 sm:gap-4 text-left ${disabled ? 'disabled' : ''}`}
      onClick={() => !disabled && state !== 'eliminated' && onClick(index)}
      disabled={disabled || state === 'eliminated'}
      initial={false}
      animate={{ opacity: state === 'eliminated' ? 0.3 : 1, x: 0 }}
      transition={{ duration: 0.2 }}
      whileHover={!disabled && state === 'default' ? { scale: 1.02 } : {}}
      whileTap={!disabled && state === 'default' ? { scale: 0.98 } : {}}
    >
      <div className="letter-badge flex-shrink-0">
        {letter}
      </div>
      <span
        className={`font-medium text-base sm:text-lg flex-1 min-w-0 break-words ${wrongRevealBlink ? 'text-inherit' : 'text-white'}`}
      >
        {answer || '...'}
      </span>
      {audiencePercent !== undefined && (
        <span className={`font-bold text-base ${wrongRevealBlink ? 'text-inherit' : 'text-cyan-400'}`}>
          {audiencePercent}%
        </span>
      )}
    </motion.button>
  );
};

/**
 * Mémoisation : props 100 % primitives/fonctions stables (handlers en useCallback
 * côté useGame), donc le comparateur shallow par défaut suffit. Évite le re-render
 * des 4 boutons à chaque tick du timer.
 */
export const AnswerButton = memo(AnswerButtonBase);
